// import React from "react";
// import { ChevronRightIcon } from "@heroicons/react/24/outline";
// import { useNavigate } from "react-router-dom";
// import { buttonPrimary } from "@/styles/buttons";


// interface Props {
//   serviceId: number;
//   serviceName?: string;
//   onApply?: () => void;
// }

// const SelfEvaluationDSP: React.FC<Props> = ({ serviceId, serviceName = "Self Evaluation Program", onApply }) => {
//   React.useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const navigate = useNavigate();

//   const handleNavigateBack = () => {
// navigate(-1);
//   };

//   // function onNewRequest(event: MouseEvent<HTMLButtonElement, MouseEvent>): void {
//   //   throw new Error("Function not implemented.");
//   // }

//   return (
//     <section className="bg-white pt-2 p-4 sm:pb-6 px-3 sm:px-4">
//       <div className="max-w-4xl mx-auto m-10 space-y-4">

//         <div>
//           <p className="text-gray-700 text-base sm:text-base">
//             A professional training program designed to sharpen interview skills through realistic simulations, expert feedback, and guided improvement. Participants gain confidence and readiness for real-world technical interviews.
//           </p>
//         </div>

//         {/* Overview */}
//         <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg p-4 border border-blue-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Overview</h2>
//           <p className="text-gray-700">
//             A professional training program designed to sharpen interview skills through realistic simulations, expert feedback, and guided improvement. Participants gain confidence and readiness for real-world technical interviews.
//           </p>
//         </div>

//         {/* Program Mode */}
//         <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg p-4 border border-indigo-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Program Mode</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
//               <span>Online or Offline (face-to-face on request)</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
//               <span>Conducted by industry professionals for authentic evaluation</span>
//             </li>
//           </ul>
//         </div>

//         {/* Duration */}
//         <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-4 border border-green-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Duration</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
//               <span>≤ 5 yrs experience: 1 hr</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
//               <span>&gt; 5 yrs experience: 1.5 hrs</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
//               <span>Optional Feedback: 1 hr (on request)</span>
//             </li>
//           </ul>
//         </div>

//         {/* Key Benefits */}
//         <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-4 border border-purple-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Key Benefits</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
//               <span>Real interview simulation (Technical)</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
//               <span>Expert-driven personalized feedback</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
//               <span>Assessment of skills & communication</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
//               <span>Role-based evaluation and confidence boost</span>
//             </li>
//           </ul>
//         </div>

//         {/* Feedback & Reporting */}
//         <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-lg p-4 border border-yellow-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Feedback & Reporting</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
//               <span>Detailed report within 3 working days</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
//               <span>Includes strengths, improvement areas & action plan</span>
//             </li>
//           </ul>
//         </div>

//         {/* Certification */}
//         <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-lg p-4 border border-cyan-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Certification</h2>
//           <p className="text-gray-700">
//             Certificate of Completion issued post-program and feedback session.
//           </p>
//         </div>

//         {/* Financials */}
//         <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-lg p-4 border border-red-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Financials</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
//               <span>Program is fee-based.</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
//               <span>Service fee based on experience level, role type, but not on delivery mode (online/offline).</span>
//             </li>
//           </ul>
//         </div>

//         {/* Deliverables */}
//         <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-lg p-4 border border-slate-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Deliverables</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
//               <span>MSelf Evaluation – Conducted by panel that comes with subject matters</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
//               <span>Feedback Session – Optional 1-hour personalized review</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
//               <span>Report – Summary of performance & improvement plan within 3 working days after the interview</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-slate-600 flex-shrink-0 mt-0.5" />
//               <span>Certificate – Upon successful completion</span>
//             </li>
//           </ul>
//         </div>

//         {/* Evaluation Parameters */}
//         <div className="bg-gradient-to-br from-lime-50 to-green-50 rounded-lg p-4 border border-lime-200">
//           <h2 className="text-base font-semibold text-gray-900 mb-3">Evaluation Parameters</h2>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
//               <span>Technical & Problem-Solving Skills</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
//               <span>Communication & Presentation</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
//               <span>Behavioral & Analytical Responses</span>
//             </li>
//             <li className="flex gap-2">
//               <ChevronRightIcon className="h-5 w-5 text-lime-600 flex-shrink-0 mt-0.5" />
//               <span>Domain Knowledge & Practical Insight</span>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SelfEvaluationDSP;

import React, { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

interface Props {
  serviceId: number;
  serviceShortName: string;
  serviceName?: string;
}

const tabs = [
  { id: "overview", label: "Overview" },
  { id: "audience", label: "Target Audience" },
  { id: "deliverables", label: "Delivarables" },
  { id: "financials", label: "Financials" },
];

const ServiceDetailPage: React.FC<Props> = ({
  serviceId,
  serviceShortName,
  serviceName = "Self Evaluation Program",
}) => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
<section className="bg-gray-50 min-h-screen p-4">
      <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left Summary Card */}
        <div className="bg-white rounded-lg shadow-md p-8 border border-gray-200">
          <div className="flex flex-col items-center text-center">
            <div
              className="rounded-full flex items-center justify-center font-bold mb-4
                         h-24 w-24 sm:h-32 sm:w-32 lg:h-40 lg:w-40
                         bg-cover bg-center"
              style={{ backgroundImage: "url('assets/images/servicelogo2.png')" }}
            >
              <span className="bg-gradient-to-b from-yellow-600 to-yellow-900 bg-clip-text text-transparent
                               text-base sm:text-3xl lg:text-4xl">
                SE
              </span>
            </div>

            <h2 className="text-base sm:text-sm font-semibold text-gray-900">{serviceName}</h2>
            <p className="text-base sm:text-sm text-gray-700 mt-3 leading-relaxed">
              A professional training program designed to sharpen interview skills through realistic simulations,
              expert feedback, and guided improvement.
            </p>
          </div>

          {/* Key Features */}
          <div className="mt-8 space-y-4 text-base sm:text-sm text-gray-800">
            <h3 className="text-base sm:text-sm font-semibold text-gray-900 mb-3">Key Features</h3>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span>Real interview simulations</span>
            </div>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span>Expert-driven feedback</span>
            </div>
            <div className="flex gap-2">
              <ChevronRightIcon className="h-6 w-6 text-blue-500" />
              <span>Confidence & readiness boost</span>
            </div>
          </div>
        </div>

        {/* Right Tabbed Content */}
        <div className="md:col-span-2 bg-white rounded-lg shadow-md border border-gray-200">
          {/* Tabs */}
          <div className="flex border-b border-gray-200 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 text-base sm:text-xl font-medium ${
                  activeTab === tab.id
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="p-8 text-gray-800 text-base sm:text-base leading-relaxed">
            {activeTab === "overview" && (
              <>
                <h3 className="text-base font-semibold text-gray-900 mb-4">Overview & Key Benefits</h3>
                <p>
                  A professional training program designed to sharpen interview skills through realistic simulations,
                  expert feedback, and guided improvement.
                </p>
                <ul className="mt-4 space-y-2 list-disc list-inside">
                  <li>Real interview simulation (Technical)</li>
                  <li>Expert-driven personalized feedback</li>
                  <li>Assessment of skills & communication</li>
                  <li>Role-based evaluation and confidence boost</li>
                </ul>
              </>
            )}

            {activeTab === "audience" && (
              <>
                <h3 className="text-base font-semibold text-gray-900 mb-4">Target Audience, Duration & Delivery Mode</h3>
                <ul className="space-y-2 list-disc list-inside">
                  <li>Target Audience: Professionals preparing for technical interviews</li>
                  <li>Duration: 1–1.5 hours depending on experience</li>
                  <li>Delivery Mode: Online or Offline (on request)</li>
                </ul>
              </>
            )}

            {activeTab === "deliverables" && (
              <>
                <h3 className="text-base font-semibold text-gray-900 mb-4">What You Get</h3>
                <ul className="space-y-2 list-disc list-inside">
                  <li>Feedback & Reporting: Detailed report within 3 working days</li>
                  <li>Certification: Certificate of Completion post-program</li>
                  <li>Deliverables: Evaluation, Feedback Session, Report, Certificate</li>
                </ul>
              </>
            )}

            {activeTab === "financials" && (
              <>
                <h3 className="text-base font-semibold text-gray-900 mb-4">Financials</h3>
                <ul className="space-y-2 list-disc list-inside">
                  <li>Program is fee-based</li>
                  <li>Fee depends on experience level and role type</li>
                  <li>Mode of delivery does not affect pricing</li>
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </section>

  );
};

export default ServiceDetailPage;
